module.exports = __webpack_public_path__ + "static/KC15-1ec4ef67ca97f83b13e14f7ddae6cc4d.png";